import { useColorMode } from '@/components/ui/color-mode';

export const useDefaultTokenAvatar = () => {
  const { colorMode } = useColorMode();

  return `/images/${colorMode === 'dark' ? 'avatar-placeholder-dark.png' : 'avatar-placeholder-light.png'}`;
};
